import { createUserManager } from 'redux-oidc';


const userManagerConfig = {
    authority: `https://myfloridacfob2c.b2clogin.com/myfloridacfob2c.onmicrosoft.com/b2c_1_signin/`,
    client_id: `021b5706-d422-4e97-bf42-a2bcd2fe443d`,
    redirect_uri: `${process.env.REACT_APP_CALLBACK_REDIRECT}`,
    post_logout_redirect_uri: `${process.env.REACT_APP_SIGNOUT_REDIRECT}`,
};

const userManager = createUserManager(userManagerConfig);

export default userManager;